import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'src/utils/baseQuery';
import { SubscriptionInfo } from 'src/models/types';
import {
  ChangeSubscriptionInvoice,
  ChangeSubscriptionRequest,
  ChangeSubscriptionResponse, ContinueSubscriptionRequest
} from '../../models/subscriptions';


export const subscriptionsApi = createApi({
  reducerPath: 'subscriptions',
  baseQuery,
  tagTypes: ['Subscriptions'],
  endpoints: (builder) => ({
    getSubscriptions: builder.query<SubscriptionInfo, void>({
      query: () => ({
        url: '/subscriptions/',
        method: 'GET',
      }),
      providesTags: ['Subscriptions'],
    }),
    getChangeInfo: builder.mutation<any, any>({
      query: (params) => ({
        url: '/subscriptions/change-info',
        method: 'POST',
        body: params,
      }),
    }),
    changeSubscription: builder.mutation<ChangeSubscriptionResponse, ChangeSubscriptionRequest>({
      query: (data) => ({
        url: '/subscriptions/changeSubscription',
        method: 'PUT',
        body: data,
      }),
    }),
    continueSubscription: builder.mutation<ChangeSubscriptionInvoice, ContinueSubscriptionRequest>({
      query: (data) => ({
        url: '/subscriptions/continueSubscription',
        method: 'PUT',
        body: data,
      }),
    }),
  }),
});

export const { 
  useGetSubscriptionsQuery,
  useGetChangeInfoMutation,
  useChangeSubscriptionMutation,
  useContinueSubscriptionMutation,
} = subscriptionsApi;
